import { useEffect } from 'react'

import { useSharedValue, withTiming, Easing, useAnimatedStyle, interpolate } from 'react-native-reanimated'
import { useStore } from '../../../models'
import { scheduleOnRN } from 'react-native-worklets'

export const useFlyAnimation = ({
  animationStarted,
  translateX,
  translateY
}: {
  animationStarted: boolean
  translateX: number
  translateY: number
}) => {
  const fly = useSharedValue(0)
  const {
    game: { setShouldPlayChipsSound }
  } = useStore()

  //@ts-ignore
  const animatedStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          translateY: interpolate(fly.value, [0, 1], [0, translateY])
        },
        {
          translateX: interpolate(fly.value, [0, 1], [0, translateX])
        }
      ],
      opacity: interpolate(fly.value, [0, 1], [1, 0])
    }
  }, [translateY, translateX])

  const onFinishAnimation = () => {
    setShouldPlayChipsSound(true)
  }

  useEffect(() => {
    if (animationStarted) {
      fly.value = withTiming(
        1,
        {
          duration: 400,
          easing: Easing.bezier(0.25, 0.1, 0.25, 1)
        },
        (finished) => {
          if (finished) {
            scheduleOnRN(onFinishAnimation)
          }
        }
      )
    } else {
      fly.value = 0
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animationStarted])

  return {
    animatedStyle,
    animationStarted
  }
}
